import { format } from 'date-fns';
import { StyleSheet } from 'react-native';

import { Box, Typography } from 'components/ui';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

import { IQuest } from '../loyalty-quest/types';
import { isStepCompleted } from '../loyalty-quest/utils';

interface IEndDateBadge {
  quest: IQuest;
}

export const EndDateBadge = ({ quest }: IEndDateBadge) => {
  const endDate = format(new Date(quest?.endDate?.toString() ?? ''), 'MMMM d');
  const challengeHasSomeProgress = !!quest?.steps?.some(step => isStepCompleted(step.status));
  const endDateText = challengeHasSomeProgress ? t('completeBy') : t('validUntil');

  const backgroundColor = challengeHasSomeProgress
    ? primitive.$errorLight
    : primitive.$blackOpacity4;

  return (
    <Box style={[styles.container, { backgroundColor }]}>
      <Typography variant="copyTwo">
        {endDateText} {endDate}
      </Typography>
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    borderRadius: 3,
    padding: spacing.$1,
  },
});
